export const BGCOLOR = [
  {
    value: '',
    cssClass: '',
  },
  {
    value: 'Light Gray',
    cssClass: 'u-bgColorLight',
  },
  {
    value: 'Brand',
    cssClass: 'u-bgColorBrand',
  },
  {
    value: 'Brand Dark',
    cssClass: 'u-bgColorBrandDark',
  },
  {
    value: 'White',
    cssClass: 'u-bgColorWhite',
  },
  {
    value: 'Green',
    cssClass: 'u-bgColorData14',
  },
  {
    value: 'Aqua',
    cssClass: 'u-bgColorAqua',
  },
  {
    value: 'Yellow',
    cssClass: 'u-bgColorYellow',
  },
  {
    value: 'Blue',
    cssClass: 'u-bgColorAction',
  },
  {
    value: 'Blue Gradient',
    cssClass: 'u-bgColorBlueGradient',
  },
  {
    value: 'Dark BG Image',
    cssClass: 'dark-bg-image',
  },
  {
    value: 'Light BG Image',
    cssClass: 'light-bg-image',
  },
]

export const ALIGNMENT = {
  Default: 'Default',
  LEFT: 'Left',
  CENTER: 'Center',
}

export const CARD_OVERLINE = {
  default: '',
  brandDark: 'u-bgColorBrandDark',
  brandMedium: 'u-bgColorAction',
  brand: 'u-bgColorBrand',
  aqua: 'u-bgColorAqua',
  yellow: 'u-bgColorYellow',
  raspberry: 'u-bgColorRaspberry',
  white: 'u-bgColorWhite',
}

export const EYEBROW_COLOR = {
  default: '',
  brandDark: 'u-textColorBrandDark',
  brandMedium: 'u-textColorAction',
  brand: 'u-textColorBrand',
  aqua: 'u-textColorAqua',
  yellow: 'u-textColorYellow',
  raspberry: 'u-textColorRaspberry',
  white: 'u-textColorWhite',
}

export const CARD_STYLE = {
  Default: {
    card: '',
    content: '',
  },
  Large: {
    card: 'card-large',
    content: 'u-paddingVert12gu u-paddingHoriz6gu',
    heading: 'u-textSizeMsrp3 u-textNormal',
    body: 'card-large-body',
    buttons: 'u-marginTop8gu',
  },
}

export const CARD_THEME = {
  'Brand Dark': {
    text: 'u-textColorBrandDark',
    bg: 'u-bgColorBrandDark',
  },
  'Brand Medium': {
    text: 'u-textColorAction',
    bg: 'u-bgColorAction',
  },
  Brand: {
    text: 'u-textColorBrand',
    bg: 'u-bgColorBrand',
  },
  Aqua: {
    text: 'u-textColorAqua',
    bg: 'u-bgColorAqua',
  },
  Yellow: {
    text: 'u-textColorYellow',
    bg: 'u-bgColorYellow',
  },
  Raspberry: {
    text: 'u-textColorRaspberry',
    bg: 'u-bgColorRaspberry',
  },
  White: {
    text: 'u-textColorWhite',
    bg: 'u-bgColorWhite',
  },
}

export const CardUtils = {
  getHeadingTextColor: (bgColor) => {
    if (
      [
        'Brand',
        'Brand Dark',
        'Blue',
        'Aqua',
        'Yellow',
        'Green',
        'Blue Gradient',
        'Dark BG Image',
      ].includes(bgColor)
    ) {
      return 'u-textColorWhite'
    }
    return 'u-textColorBrandDark'
  },

  getBodyTextColor: (bgColor) => {
    if (
      [
        'Brand',
        'Brand Dark',
        'Blue',
        'Aqua',
        'Yellow',
        'Green',
        'Blue Gradient',
        'Dark BG Image',
      ].includes(bgColor)
    ) {
      return 'u-textColorWhite'
    }
    return 'u-textColorSlateDark'
  },

  getBorder: (bgColor) => {
    if (bgColor === 'White' || bgColor === 'Light BG Image') {
      return 'card-border-light u-border u-borderColorNeutral'
    }
    return ''
  },

  getBackground: (bgColor) => {
    return BGCOLOR.find((color) => color.value === bgColor)?.cssClass || ''
  },

  getCardPadding: (bgColor, commonPadding = '4gu') => {
    if (bgColor !== '') {
      return `u-paddingVert${commonPadding} u-paddingHoriz${commonPadding}`
    }
    return ''
  },

  getCardHeaderPadding: (
    bgColor,
    layout,
    imagePosition,
    commonPadding = '4gu'
  ) => {
    if (bgColor === '') {
      if (layout === 'Horizontal') {
        return imagePosition === 'After'
          ? `u-sm-paddingLeft0 u-paddingLeft${commonPadding}`
          : `u-sm-paddingRight0 u-sm-paddingBottom${commonPadding} u-paddingRight${commonPadding}`
      }
      return imagePosition === 'After'
        ? `u-paddingTop${commonPadding}`
        : `u-paddingBottom${commonPadding}`
    }
    if (layout === 'Horizontal') {
      return imagePosition === 'After'
        ? `u-sm-paddingVert0 u-sm-paddingRight0 u-paddingVert${commonPadding} u-paddingRight${commonPadding}`
        : `u-sm-paddingVert0 u-sm-paddingLeft0 u-paddingVert${commonPadding} u-paddingLeft${commonPadding}`
    }
    return ''
  },

  getAccentBorderStyle: (bgColor, layout, imagePosition, accentBorder) => {
    const margin =
      bgColor === ''
        ? imagePosition === 'After'
          ? 'u-marginLeft2gu u-sm-marginLeft0'
          : 'u-marginRight2gu u-sm-marginRight0'
        : ''
    const thickness =
      accentBorder === 'Thick'
        ? 'thick '
        : accentBorder === 'Thin'
          ? 'thin '
          : ''
    const direction = layout === 'Horizontal' ? `hori ${margin}` : 'vert '
    return thickness + direction
  },

  getIsDarkTheme: (bgColor) => {
    return [
      'Brand',
      'Brand Dark',
      'Blue',
      'Aqua',
      'Yellow',
      'Green',
      'Blue Gradient',
      'Dark BG Image',
    ].includes(bgColor)
  },
}
